export default __webpack_public_path__ + "static/media/supermarket.b0d40a97.jpg";